"use strict";

exports.__esModule = true;
exports.default = void 0;

var _utils = require("@material-ui/core/utils");

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16.393 20.249c-.195 0-.401-.056-.61-.166l-3.11-2.148c-.334-.177-1.011-.177-1.345-.001l-3.11 2.154c-.5.262-1.003.199-1.286-.139-.138-.163-.283-.459-.2-.943l.595-3.98c.067-.392-.131-1.001-.416-1.279l-2.766-2.451c-.339-.331-.468-.725-.353-1.082.116-.355.451-.598.92-.667l3.725-.507c.394-.057.912-.434 1.09-.792l1.555-3.864c.419-.849 1.418-.849 1.837 0l1.555 3.864c.177.357.696.734 1.09.792l3.726.507c.468.068.804.311.919.667s-.013.75-.352 1.082l-2.766 2.451c-.285.278-.483.887-.416 1.279l.595 3.976c.083.483-.062.779-.2.943a.867.867 0 0 1-.676.304zm-11.52-9.681 2.757 2.441c.532.52.838 1.462.712 2.193l-.592 3.966 3.098-2.147c.63-.33 1.674-.331 2.304.001l3.098 2.142-.592-3.962c-.126-.731.18-1.674.712-2.193l2.757-2.441-3.713-.506c-.733-.107-1.536-.689-1.865-1.354L12 4.855l-1.549 3.853c-.329.666-1.132 1.248-1.866 1.354l-3.712.506z"
}), 'FavouriteOutlined');

exports.default = _default;